module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page17"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber"
  }, [_c('span', {
    staticClass: "xrefInternal"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/contents#ch_02"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("chapter 2")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/17.jpg"
    }
  })]), _vm._v(" "), _c('h2', {
    staticClass: "chapterTitle"
  }, [_vm._v("CALL 2344, THURSDAY, 12:23 "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("A.M.")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I had to call")])]), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("you tonight. Well…I had to call someone…someone who might understand my story. Everyone thinks I’m crazy. But I’m not")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I swear. Though I think if I don’t find someone who believes me")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I may truly go mad.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("It all started when my marriage went on the skids.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("You know how the closer you get to someone")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the farther away they often seem? That’s the way it was with my husband. He shut a door inside himself")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and threw away the key. Every conversation became an argument. Every question")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("an accusation. Eventually")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he even recoiled from my touch.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("One night it got really bad. We said the kind of stuff you should never say to another human being. Evil stuff. Stuff that hurt right down to the bone.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I knew we couldn’t go on this way. So I grabbed my children")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Mateo and Josephina")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and ran from the house. And I mean")]), _vm._v(" ran, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pulling the children behind me like rag dolls. They screamed")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("they cried")]), _vm._v("; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("but I just had to move")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("to feel the rush of wind against my face. Nothing had felt this good in months.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("After a few blocks")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("my head cleared and the insanity of my actions kicked in. Where was I going? What would I do?")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Before I could even begin to answer these questions")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I saw a woman waving at us from down the block. It was Lorenza")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("a friend from my job. She rushed up to us")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("concerned.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I tried to explain what had happened. I don’t think I made much sense. But she nodded compassionately")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("placed an arm "), _c('a', {
    attrs: {
      "id": "page19"
    }
  }), _vm._v("around my shoulder, and led me and the children back to her house.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("She put Josephina and Mateo to bed in her spare room")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("fixed me a cup of tea")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and I had a good long cry. She understood where I was coming from. She had a lousy marriage too. And although I’d never met her husband")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("he sounded an awful lot like mine")]), _vm._v(": "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the same distance")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the same coldness")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the same…well…everything.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("After talking with Lorenza")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I realized I couldn’t go back. My marriage had been over for years. It had just taken me a long time to realize it. But I still had nowhere to go")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and no way to get there.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Again")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lorenza came to the rescue.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("She told me that her parents owned a small house on the outskirts of town. They rented it out to earn some extra income. But it wasn’t occupied at the time")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and Lorenza told me that the children and I could stay there as long as we wanted.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("It wasn’t much of a place")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("she said")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("but it would give us a roof over our heads while I planned our next move.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("She asked if I wanted to go. I nodded. The longer I stayed")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("the greater the chance my husband might show up looking for me.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("So we grabbed the children")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bundled them into the car")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and drove off into the night.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("We drove for hours. The house was not on the outskirts of town at all")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("but in a sleepy desert community some two hundred miles away. At that point I didn’t care. The motion of the car relaxed me")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and the desert air smelled wonderful.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("At around 2 "), _c('span', {
    staticClass: "smallCaps"
  }, [_vm._v("A.M")]), _vm._v("., Lorenza turned off the highway and onto a gravel road. We continued on for about a mile")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and then parked in a clearing. I pulled the kids out of the car")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and looked around. The moon was almost full")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and it illuminated everything around me. I spotted a cactus or two")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and the vague shape of distant mountains")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("but no house.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I turned back to Lorenza")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("only to find that she and the car had "), _c('a', {
    attrs: {
      "id": "page20"
    }
  }), _vm._v("vanished. Even the gravel road we’d been driving down only scant seconds before was nowhere to be seen.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Worst of all…my children were gone.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I called their names loudly")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("frantically")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("into the moonlit night. But the only response was the wind whipping across the desert")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and the distant")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("plaintive call of a coyote.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Finally")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("not knowing what else to do")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I started walking. I walked and I walked")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("each step more laborious than the last.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("As dawn approached")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I reached the highway. After several minutes")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("a car picked me up")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("and drove me to a nearby bus station. Once inside")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I found a pay phone and called my husband.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I was shocked when Lorenza answered the phone. I asked her if Josephina and Mateo were all right. She told me they were")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("but was curious about why I wanted to know.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I told her that I had the right to know the whereabouts of my own children.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("“Your children?” Lorenza said. “Josephina and Mateo are my children.”")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("I can’t remember what I said next. I screamed")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I wept")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I sounded like a madwoman.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Finally")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lorenza put a man on the phone. A man she called “her husband.” I recognized the voice immediately. It was")]), _vm._v(" my "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("husband.")])]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("He spoke to me calmly")]), _vm._v(", "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sounding as distant as ever.")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8623f86","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter02.vue
// module id = 78
// module chunks = 0